export interface RemoteState<T> { data: T | null; loading: boolean; error: boolean }
/** Ignore obsolete replies on month/teacher changes, retry, or unmount. Never show old data as current. */
export function createLatestLoader<T>(publish: (state: RemoteState<T>) => void) {
  let version = 0
  return {
    async load(request: () => Promise<T>) {
      const current = ++version
      publish({ data: null, loading: true, error: false })
      try {
        const data = await request()
        if (current === version) publish({ data, loading: false, error: false })
      } catch {
        if (current === version) publish({ data: null, loading: false, error: true })
      }
    },
    cancel() { version++ },
  }
}
